<template>
  <layout-editor-page
    :title="formTitle"
    isTabsPage
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    :error="error"
    @command="setCommand"
  >
    <!-- MAIN TABS -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane
        name="rfq"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('rfq')}}</span>
        </template>
        <tab-rfq
          :moduleName="moduleName"
          :eventID="eventID"
          :fullDataRFQ="fullDataRFQ"
          :hasCreateNew="hasCreateNew"
          :data="data"
          :formData="formData"
          @command="mainTabController" />
      </el-tab-pane>
      <el-tab-pane
        name="invoice"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('invoice')}}</span>
        </template>
        <tab-invoice
          :moduleName="moduleName"
          :eventID="eventID"
          :rfqid="data.rfqid"
          :po="data.po"
          :customerCompanyID="data.customerCompanyID"
        />
      </el-tab-pane>
      <el-tab-pane
        name="related-po-wo"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('related-po-wo')}}</span>
        </template>
        <tab-related-po-wo
          :moduleName="moduleName"
          :eventID="eventID"
          :rfqid="data.rfqid"
          :po="data.po" />
      </el-tab-pane>
      <el-tab-pane
        name="customer-po-follow-up"
      >
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('customer-po-follow-up')}}</span>
        </template>
        <tab-customer-po-follow-up :rfqid="data.rfqid" />
      </el-tab-pane>
    </el-tabs>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'

export default {
  name: 'EditorPart',
  mixins: [FormWrapper],
  components: {
    'tab-rfq': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './TabRFQ/Index'),
    'tab-invoice': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './TabInvoice/Index'),
    'tab-related-po-wo': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './TabRelatedPOWO/Index'),
    'tab-customer-po-follow-up': () => import(/* webpackChunkName: 'CustomerPoOpen' */ './TabCustomerPoFollowUp/Index')
  },
  props: {
    moduleName: { type: String, required: true },
    eventID: { type: String, required: true }
  },
  watch: {
    isVisible (value) {
      if (!value) {
        this.$store.dispatch(`${this.moduleName}/resetState`)
      }
    }
  },
  data () {
    return {
      isVisibleReports: false,
      activeTab: 'rfq',
      error: null
    }
  },
  computed: {
    formTitle () {
      let titleConfig = [
        { label: this.L10n('po'), field: 'po' },
        { label: this.L10n('for'), field: 'customerCompanyName' },
        { label: this.L10n('based-on-rfq'), field: 'rfqid' }
      ]
      let result = titleConfig.reduce((result, config) => {
        let value = this.fullDataRFQ[config.field]
        value && result.push(`${config.label} ${value}`)
        return result
      }, [])
      return result.join(' ')
    },
    dataViewRFQ () {
      return this.$store.state[this.moduleName].dataViewRFQ
    },
    fullDataRFQ () {
      return {
        ...this.data,
        ...this.formData,
        ...this.dataViewRFQ
      }
    }
  },
  methods: {
    handleTabClick (tab) {
      this.$bus.$emit(`on-click-tab-${tab.name}`)
    },
    formModel () {
      return {
      }
    },
    handleCameData () {
      this.error = null
    },
    handleErrorCameData (error) {
      this.error = error
    },
    mainTabController (command, data) {
      switch (command) {
        case 'update-form-data':
          this.handleFormData(data)
          break
        default:
          this.setCommand(command)
      }
    },
    // Mixins
    handleChangeID () {
      this.activeTab = 'rfq'
    }
  }
}
</script>

<style lang="stylus">
  .grid-parts__wrap-inner-tools{
    .grid-tools-wrap{
      .tool-controls{
        display flex
        align-items flex-start
        flex-wrap wrap
        justify-content flex-end
        > li {
          margin 1.9rem 0 1rem 1rem !important
        }
      }
    }
    .inner-tool-controls{
      position relative
      z-index 11
    }
  }
  @media only screen and (max-width: 576px) {
    .grid-parts__wrap-inner-tools{
      .grid-tools-wrap{
        flex-direction column
        .grid-toolbar{
          order 2
        }
        .tool-controls{
          order 1
          > li {
            width 100%
            margin 0 0 1rem 0 !important
            > .btn {
              width 100%
            }
          }
        }
      }
    }
  }
</style>
